import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { Column } from '../Grid'
import { Text } from '../Text'

const Checkbox = ({
  name,
  value,
  disabled,
  register,
  label,
  defaultValue,
  onClick,
  checked,
  icon,
  selectOverflow,
  ...props
}) => (
  <Container {...props}>
    <CheckboxContainer onClick={onClick}>
      <HiddenCheckbox
        onKeyUp={event => {
          if (event.key === 'Enter') {
            onClick()
          }
        }}
        checked={checked}
        name={name}
        ref={register}
        defaultChecked={defaultValue}
        value={value}
        {...props}
      />
      <StyledCheckbox checked={checked} onClick={onClick}>
        <Icon viewBox='0 0 24 24'>
          <polyline points='20 6 9 17 4 12' />
        </Icon>
      </StyledCheckbox>
      {icon && <SvgContainer>{icon}</SvgContainer>}
      <Label disabled={disabled} selectOverflow={selectOverflow}>
        {label}
      </Label>
    </CheckboxContainer>
  </Container>
)

const Label = styled(Text)(
  ({ theme: { colors }, disabled, selectOverflow }) => `
  cursor: pointer;
  font-size: 14px;
  color: ${disabled ? colors.gray.n500 : colors.black};
  margin-left: 12px;
  margin-bottom: 0;
  text-overflow: ellipsis;
  text-align: left;
  max-width: ${selectOverflow ? '87%' : 'auto'};
  white-space: ${selectOverflow && 'nowrap'};
  overflow: ${selectOverflow && 'hidden'};

  span {
    color: #000 !important;
  }
  a {
    color: #FF7708;
    text-decoration: underline !important;
  }
`
)

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`
const Icon = styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 2px;
  vertical-align: super;
`
const StyledCheckbox = styled.div(
  ({ theme: { colors, shadows }, checked }) => `
  display: inline-block;
  min-width: 16px;
  min-height: 16px;
  max-width: 16px;
  max-height: 16px;
  background: ${checked ? colors.primary : colors.white};
  border: 0.5px solid ${colors.gray.n300};
  border-radius: 3px;
  transition: all 150ms;

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px ${colors.primary};
  }
`
)

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  vertical-align: middle;
  cursor: pointer;
  inline-size: max-content;
  max-width: 100%;

  @media (max-width: 768px) {
    align-self: flex-start;
  }
`

const Container = styled(Column)`
  position: relative;
  width: 100%;
`
const SvgContainer = styled.svg`
  margin-left: 20px;
  width: 22px;
  height: 15px;
`

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.bool,
  checked: PropTypes.bool,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  register: PropTypes.func
}

export { Checkbox }
